import InitApi from "api/InitApi";
import { useMutation, useQueryClient } from "react-query";
import useTokenStore from "store/tokenStore";
import toast from "react-hot-toast";

const useAddSeats = (subscriptionId, onSuccess) => {
	const { accessToken } = useTokenStore();
	const queryClient = useQueryClient();

	const addSeats = async (data) => {
		const instance = await InitApi({ accessToken });
		const res = await instance.post(`subscriptions/${subscriptionId}/add-seats`, data);

		queryClient.invalidateQueries("is_subscribed");
		queryClient.invalidateQueries("subscriptions");
		queryClient.invalidateQueries("my-profile");
		queryClient.invalidateQueries("calculate-prorated-cost");
		queryClient.invalidateQueries("books");
		return res.data;
	};

	return useMutation((data) => addSeats(data), {
		onSuccess: (data) => {
			toast.success(data?.message || "Seats added successfully!");
			if (onSuccess) onSuccess(data);
		},
		onError: (error) => {
			const message =
				error?.response?.data?.message ||
				error?.message ||
				"Failed to add seats. Please try again.";
			toast.error(message);
		},
	});
};

export default useAddSeats;
